<div [style.height.px]="headerHeight()" class="header-wrapper-container">
  <div class="fixed-wrapper" [style.top.px]="loggedIn() ? headerOffset() : '0'" #fixedwrapper>
    @if (loggedIn() && !mobileMenuActive()) {
      <a
        [style.height.px]="headerOffset()"
        (focus)="focusHandler()"
        (blur)="blurHandler()"
        class="sr-only skip-content"
        (click)="focusMainContent()"
        (keyup.enter)="focusMainContent()"
        dsContent
        [contentPath]="'shared.skipToContent'"
      ></a>
    }
    <ds-header
      [loaded$]="dataLoaded$"
      [loggedIn]="loggedIn()"
      [isPartner]="isPartner()"
      [homeUrl]="homeUrl()"
      [notifications]="notifications()"
      [linkArray]="linkArray$() | async"
      [brandInfo]="brandInfo()"
      [headerLogo]="headerLogo()"
      [skipContentFocus]="skipContentFocus()"
      [contactDetails]="contactDetails$ | async"
      (linkClickEvent)="linkClicked($event)"
      (sublinkClickEvent)="sublinkClicked($event)"
      (notificationDismissClickEvent)="notificationDismissClicked($event)"
      class="app-header block"
    ></ds-header>
    <ds-roofline [loggedIn]="loggedIn()" class="roofline-container none lg-block"></ds-roofline>
    @if (showHeader()) {
      <ds-docking-bar></ds-docking-bar>
    }
  </div>
</div>
<ds-session-timeout></ds-session-timeout>
